import Header from "../layout/header";

const PUBLISHED_APPS = [
  {
    id: "zktimes-console",
    title: "Console App",
    subtitle: "( ZKTimes )",
    description: "Download the ZKTimes console application for attendance and device management.",
    buttonLabel: "Download ZKTimes Console App",
    downloadUrl: "https://tecgym.app/publish/zktimes/TECGym.Console.App.zip",
    accent: "#187718"
  },
  {
    id: "zktimes-db-schema",
    title: "Database Schema Update",
    subtitle: "( ZKTimes )",
    description: "Download the SQL script required to update the ZKTimes database schema.",
    buttonLabel: "Download DB Schema Update",
    downloadUrl: "https://tecgym.app/publish/zktimes/ZKTimesDB_Schema_Update.sql",
    accent: "#187718"
  },
  {
    id: "wdms-32bit",
    title: "Console App",
    subtitle: "( WDMS 32-bit )",
    description: "Download the 32-bit WDMS console application for device and attendance synchronization.",
    buttonLabel: "Download WDMS 32-bit",
    downloadUrl: "https://tecgym.app/publish/wdms/WDMS_console_32bit.zip",
    accent: "#3b82f6"
  },
  {
    id: "wdms-64bit",
    title: "Console App",
    subtitle: "( WDMS 64-bit )",
    description: "Download the 64-bit WDMS console application for device and attendance synchronization.",
    buttonLabel: "Download WDMS 64-bit",
    downloadUrl: "https://tecgym.app/publish/wdms/WDMS_console_64bit.zip",
    accent: "#3b82f6"
  }
];

function PublishedPage() {
  const handleDownload = (app) => {
    const link = document.createElement("a");
    link.href = app.downloadUrl;
    link.download = "";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="main">
      <Header />
      <main style={pageStyle}>
        <div className="branchMenu" aria-label="Published tabs">
          <button type="button" className="active" style={selectedTabStyle}>
            Published
          </button>
        </div>

        <div className="contentArea" style={tabContentStyle}>
          <div style={headerStyle}>
            <h1 style={headingStyle}>Published</h1>
            <p style={subheadingStyle}>Download console applications for ZKTimes and WDMS.</p>
          </div>

          <div style={cardsGridStyle}>
            {PUBLISHED_APPS.map((app) => (
              <div
                key={app.id}
                style={cardStyle}
                onMouseEnter={(event) => {
                  event.currentTarget.style.borderColor = app.accent;
                  event.currentTarget.style.transform = "translateY(-4px)";
                  event.currentTarget.style.boxShadow = `0 8px 24px ${app.accent}33`;
                }}
                onMouseLeave={(event) => {
                  event.currentTarget.style.borderColor = "var(--home-border, #444)";
                  event.currentTarget.style.transform = "translateY(0)";
                  event.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.3)";
                }}
              >
                <div style={{ ...iconWrapStyle, backgroundColor: `${app.accent}22`, color: app.accent }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <rect x="2" y="3" width="20" height="14" rx="2" />
                    <line x1="8" y1="21" x2="16" y2="21" />
                    <line x1="12" y1="17" x2="12" y2="21" />
                  </svg>
                </div>

                <h2 style={cardTitleStyle}>
                  {app.title}
                  <span style={cardSubtitleStyle}>{app.subtitle}</span>
                </h2>
                <p style={cardDescriptionStyle}>{app.description}</p>

                <button
                  type="button"
                  onClick={() => handleDownload(app)}
                  style={{ ...downloadButtonStyle, backgroundColor: app.accent }}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                  {app.buttonLabel}
                </button>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}

const pageStyle = {
  minHeight: "calc(100vh - 80px)",
  padding: "clamp(16px, 3vw, 24px) clamp(12px, 3vw, 20px)",
  maxWidth: "100%",
  boxSizing: "border-box",
  background: "linear-gradient(135deg, #1e2127 0%, #2a2d35 100%)"
};

const selectedTabStyle = {
  color: "#000"
};

const tabContentStyle = {
  padding: "clamp(14px, 3vw, 24px)",
  maxWidth: "100%",
  boxSizing: "border-box"
};

const headerStyle = {
  marginBottom: "28px"
};

const headingStyle = {
  margin: "0 0 8px 0",
  fontSize: "28px",
  fontWeight: 700,
  color: "var(--home-heading, #fff)"
};

const subheadingStyle = {
  margin: 0,
  fontSize: "15px",
  color: "var(--home-muted, #888)"
};

const cardsGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 260px), 1fr))",
  gap: "24px",
  width: "100%",
  boxSizing: "border-box"
};

const cardStyle = {
  backgroundColor: "var(--home-card-bg, #2a2d35)",
  border: "1px solid var(--home-border, #444)",
  borderRadius: "16px",
  padding: "28px",
  boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
  transition: "all 0.3s ease",
  display: "flex",
  flexDirection: "column",
  gap: "14px"
};

const iconWrapStyle = {
  width: "56px",
  height: "56px",
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

const cardTitleStyle = {
  margin: 0,
  fontSize: "22px",
  fontWeight: 700,
  color: "var(--home-heading, #fff)",
  display: "flex",
  flexWrap: "wrap",
  alignItems: "baseline",
  gap: "8px"
};

const cardSubtitleStyle = {
  fontSize: "16px",
  fontWeight: 600,
  color: "var(--home-muted, #888)"
};

const cardDescriptionStyle = {
  margin: 0,
  fontSize: "14px",
  lineHeight: 1.5,
  color: "var(--home-muted, #888)",
  flex: 1
};

const downloadButtonStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  marginTop: "8px",
  padding: "12px 18px",
  fontSize: "14px",
  fontWeight: 700,
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  width: "100%"
};

export default PublishedPage;
